<template>

    <div class="vx-row">
        <div class="vx-col xl:w-1/2 w-full mt-6" :key="index" v-for="(tr, index) in GPUs">
            <single-g-p-u-card :g-p-u="tr"/>
        </div>
    </div>
</template>
<script>

    import SingleGPUCard from './SingleGPUCard'
    export default {
        components: { SingleGPUCard },
        data() {
            return {

                GPUs: []

            }
        },
        methods: {
            loadData() {
                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/gpu/')
                loadPromise.then(function(response) {
                    thisIns.GPUs = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })
            }
        },
        mounted() {
            this.loadData()
        }
    }

</script>
